import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    journalistDetailMixin
} from './vue/mixins/journalist';
import lazyload from './features/lazy-load';
import stickyScroll from "./features/sticky-scroll";

lazyload();
stickyScroll();

const mixins = [];
mixins.push(journalistDetailMixin);

initMain(mixins, {
    JournalistPager: () => import('./vue/components/journalist-pager/JournalistPager.vue'),
    JournalistsAc: () => import('./vue/components/journalists-ac/JournalistsAc.vue'),
    Trends: () => import('./vue/components/trends/Trends.vue')
}, []);

header();